export default __webpack_public_path__ + "static/media/img_vision_mission.4350d31a.png";